<!-- <p>Soy service-order-content</p> -->
<!-- CONTENIDO DINAMICO DEL COMONENTE - dinamico -->
<div class="dynamic-content-container">
    <ng-template ad-host></ng-template>
  </div>  